export const TOKEN = "cusm-jwt-token"
export const USERNAME = "cusm-username-token"